import { useContext } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import navBarStyle from "../styles/nav.module.scss";

function NavBarExt() {
  const { collection } = useContext(UserContext);
  const navigate = useNavigate();

  return (
    <div className={navBarStyle.bar}>
      <div
        onClick={() => navigate("library")}
        className={navBarStyle.logo}
      >
        MATLIB
      </div>
      <div className={navBarStyle.navigation}>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "inactive")}
          to="collection"
        >
          COLLECTION{" "}
          <span className={navBarStyle.collectionCount}>
            {collection?.length || 0}
          </span>
        </NavLink>
      </div>
    </div>
  );
}

export default NavBarExt;
